import { getParamsUrl } from '@/helpers/request'
import Repository from './Repository'

const action = '/payments-statistics'

export default {
  getRegisterData(settings) {
    return Repository.get(action + getParamsUrl(settings))
  },
}
